<template>
  <div>
    <content-header title="Store" :sub-title="subTitle" class="mb-0 mt--10"/>
    <el-row class="mt-20" v-if="isLoaded">
      <el-col :span="24">
        <!--- Desktop Table --->
        <el-table :data="registration.saleableItems" class="item-table desktop-table">
          <el-table-column label="Product" width="auto">
            <template slot-scope="scope">
              <div class="d-flex align-items-center product-container">
                <div class="flex-0 d-flex align-items-center">
                  <el-avatar class="d-flex flex-center fs-25 product-avatar" shape="square" icon="el-icon-picture" :size="54"></el-avatar>
                </div>
                <div class="product-info flex-1 d-flex flex-column ml-15">
                  <div class="name">{{ scope.row.name }} - ${{ scope.row.price | parsePrice }}</div>
                  <div class="description">{{ scope.row.description }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Size" width="150">
            <template slot-scope="scope">
              <el-select v-if="scope.row.requiresSize" class="mt-05 w-100" placeholder="Select" v-model="scope.row.size">
                <el-option-group
                  v-for="group in getSizeGroups(scope.row)"
                  :key="group.label"
                  :label="group.label">
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-option-group>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="QTY" width="110">
             <template slot-scope="scope">
              <el-qty-input v-model="scope.row.qty"/>
             </template>
          </el-table-column>
        </el-table>

        <!--- Mobile Table --->
        <el-table :data="registration.saleableItems" class="item-table mobile-table">
          <el-table-column label="Product">
            <template slot-scope="scope">
              <div class="d-flex align-items-center product-container">
                <div class="flex-0 d-flex align-items-center">
                  <el-avatar class="d-flex flex-center fs-25 product-avatar" shape="square" icon="el-icon-picture" :size="54"></el-avatar>
                </div>
                <div class="product-info flex-1 d-flex flex-column ml-15">
                  <div class="name">{{ scope.row.name }}</div>
                  <div class="name fs-10">${{ scope.row.price | parsePrice }}</div>
                  <div class="description">{{ scope.row.description }}</div>
                </div>
              </div>
              <el-divider class="mt-15"/>
              <div class="d-flex justify-content-end">
                <div v-if="scope.row.requiresSize">
                  <div class="fs-08">Size:</div>
                  <el-select placeholder="Select" v-model="scope.row.size" style="width: 100px">
                    <el-option-group
                      v-for="group in getSizeGroups(scope.row)"
                      :key="group.label"
                      :label="group.label">
                      <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <div class="ml-10">
                  <div class="fs-08">QTY:</div>
                  <el-qty-input v-model="scope.row.qty" style="width: 70px"/>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <div class="d-flex justify-content-between mx-10">
          <h2>Store Cart Total:</h2>
          <h2>${{cartTotal}}</h2>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'Store',
  props: {
    value: Object
  },
  data() {
    return {
      isLoaded: false,
      subTitle: 'The entity is offering the following product(s) that can be added to your registration',
      registration: {},
      allSizes: undefined,
    };
  },
  async mounted() {
    this.isLoaded = false;
    this.registration = this.value;

    const sizeGuideListsRes = await this.$http.get('/assemble/api/v1/portal/size-guide-list');
    this.allSizes = this.getFormattedSize(sizeGuideListsRes.data.data);

    _.forEach(this.registration.saleableItems, (i, idx) => {
      if (i.qty === undefined) {
        this.$set(this.registration.saleableItems[idx], 'qty', 0);
      }
    });
    this.isLoaded = true;
  },
  methods: {
    getFormattedSize(allSizesDefault) {
      const formatted = allSizesDefault.map((type) => {
        const options = type.options.map((op) => op.options);
        _.assign(type, { options: _.flattenDeep(options) });
        return type;
      });
      return formatted;
    },
    getSizeGroups(row) {
      return row.sizeList ? row.sizeList : this.allSizes;
    },
    updateStep(step) {
      // Validate requires size
      let isValid = true;
      _.forEach(this.registration.saleableItems, (i) => {
        if (i.requiresSize && i.qty > 0 && !i.size) {
          isValid = false;
          this.$message.error(`Size is required for ${i.name}`);
          return false;
        }
        return true;
      });

      if (isValid) this.$emit('update-step', this.registration, step);
    },
  },
  computed: {
    cartTotal() {
      let total = 0;
      _.forEach(this.registration.saleableItems, (i) => {
        total += i.qty * i.price;
      });
      return (total / 100).toFixed(2);
    }
  },
  filters: {
    parsePrice(val) {
      return (val / 100).toFixed(2);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  &.mobile-table {
    display: none;
  }

  @media only screen and (max-width: $sm) {
    &.mobile-table { display: block !important; }
    &.desktop-table { display: none !important; }
  }

  th {
    background: #F6F8FA !important;
    padding-left: 1em;
    padding-right: 1em;
  }

  td {
    background-color: white !important;
    padding: 2em 1em;
  }
}

.product-container {
  .product-avatar {
    background: white !important;
    border: 1px solid rgba(45, 58, 69, 0.2);
    border-radius: 0;
    color: rgba(45, 58, 69, 0.2);
  }

  .product-info {
    .name {
      color: #2D3A45;
      font-size: 1.2em;
    }

    .description {
      font-family: $fontLight;
    }
  }
}
</style>
